import captureException from 'utils/captureException';

export const logUnknownSuggestionPipeline = (funcName: string) =>
  captureException(new Error('unknown suggestion pipeline encountered'), {
    functionName: funcName,
  });
